<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            title="医師の利用制限解除"
            ok-title="利用制限解除"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            @ok="unrestrictDoctor">
            <div v-if="doctor">
                <div class="modal-body">
                    <div class="jumbotron pt-3 pb-3">
                        <p>名前：{{ doctor.full_name }} （ {{ doctor.full_name_kana }} ）</p>
                        <p class="mb-0">{{ $locale.consultation_host }}科：{{ medicalCourseNames }}</p>
                    </div>
                    <p class="text-center">上記の医師の利用制限を解除します。<br>よろしいですか？</p>
                </div>
            </div>
            <div
                slot="modal-footer"
                class="w-100">
                <div v-if="!inProgress">
                    <button class="btn btn-yokumiru-orange float-right" @click="unrestrictDoctor">制限解除</button>
                    <button class="btn btn-yokumiru-gray float-right mr-2" @click="close">キャンセル</button>
                </div>
                <div
                    v-else
                    class="d-flex justify-content-center align-items-center">
                    <b-spinner variant="yokumiru-user"/>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import constants from '../../../constants'

export default {
    name: "StopDoctorModal",
    data() {
        return {
            inProgress: false,
            modalShow: false,
            doctor: null,
            medicalCourseNames: '',
        }
    },
    created: function () {
        bus.$on('open-modal-unrestrict-doctor', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-unrestrict-doctor')
    },
    methods: {
        open: function (data) {
            this.modalShow = true
            this.doctor = data

            data.medical_courses.forEach((medicalCourse) => {
                this.medicalCourseNames += `${medicalCourse.name}、`
            })

            if (this.medicalCourseNames.length > 0) {
                this.medicalCourseNames = this.medicalCourseNames.slice(0, -1)
            }
        },

        close: function () {
            this.modalShow = false
            this.medicalCourseNames = ''
        },

        unrestrictDoctor: async function () {
            if (this.inProgress) return
            this.inProgress = true

            await axios.put(`${constants.admin.doctors.endpoint.base}/${this.doctor.id}/unrestrict`)
                .then(() => {
                    bus.$emit('alert-success', '医師の利用制限を解除しました。')
                    bus.$emit('fetch-doctors')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors') &&
                        response.data.errors.hasOwnProperty('message')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>
